export default __webpack_public_path__ + "static/Card7-f68b3f6be0bde5fea23af58d238d526c.png";